export const GET_AUTH_URL = "auth/user";
export const VERIFY_TOKEN_URL = "auth/token/verify";
export const REFRESH_TOKEN_URL = "auth/token";
export const GRAPHQL_URL = "graphql";
